var React = require('react');

function ArrowRight1 (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;fill-rule:evenodd;}")),React.createElement("title",{"key":1},"arrow-right-1"),React.createElement("path",{"className":"cls-1","d":"M5.5.75,16.22,11.47a.749.749,0,0,1,0,1.06L5.5,23.25","key":2})]);
}

ArrowRight1.defaultProps = {"id":"Regular","viewBox":"0 0 24 24"};

module.exports = ArrowRight1;

ArrowRight1.default = ArrowRight1;
